export default "__VITE_ASSET__CVKC_2Pe__"